import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private translate: TranslateService,
        private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((httpError: HttpErrorResponse) => {
            this.handleError(httpError);
            if (httpError.status === 401 || httpError.status === 403) {
                this.authenticationService.logout();
                location.reload(true);
            }

            const error = httpError.error.message || httpError.statusText;
            return throwError(error);
        }))
    }

    private handleError(httpError: HttpErrorResponse): any {

        console.log('handleError', httpError);
        if (httpError.status == 0) {
            this.handleNotification('server_not_available');
        }
        else if (httpError.error instanceof ErrorEvent) {
            console.error('HttpService Unknown error:', httpError.error.message);
            this.handleNotification('unknown_error');
        } else {
            // The backend returned an unsuccessful response code.
            const errResponse = httpError.error;
            console.error('Backend error:', errResponse.message);
            this.handleNotification(errResponse.message);
        }
        return throwError(httpError); //do not send back error objects if error occured
    }

    private handleNotification(title: string, description?: string) {
        title = title ? this.translate.instant(`apiMessages.${title}`) : '';
        description = description ? this.translate.instant(`apiMessages.${description}`) : '';
        if (title || description) {
            this.toastr.error(description, title);
        }
    }
}
